/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.10",
    versionName: "0.2.0-nightly.2025.11.10",
    versionChannel: "nightly",
    buildDate: "2025-11-10T00:09:11.826Z",
    commitHash: "8dca07698b317167c7d210498999e3d39351c38c",
};
